import { Portal } from '@mui/material';
import { FileCollectionT, ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement } from 'react';
import { PDFIcon, ExcelIcon, DocumentIcon } from '../../../../../icons/appIcons';
import { ObosX, ObosDownload } from '../../../../../icons/obos/obosIcons';
import { Modal } from '../../../../overlay';

type ObjectViewMobileDocumentModalProps={
    showDocumentModal: boolean;
    setShowDocumentModal: (value: boolean) => void;
    selectedObject?: ObjectContainerClientT;
    fileCollections?: FileCollectionT[];
};
export const getIcon = (filename: string) => {
    switch (filename.split('.').pop()) {
    case 'pdf':
        return <PDFIcon className={'bv-ov-doc-icon'}/>;
    case 'xlsx':
    case 'xlsb':
    case 'csv':
        return <ExcelIcon className={'bv-ov-doc-icon'}/>;
    default:
        return <DocumentIcon className={'bv-ov-doc-icon'}/>;
    }
};

const ObjectViewMobileDocumentModal: React.FC<ObjectViewMobileDocumentModalProps> = ({ setShowDocumentModal, showDocumentModal, selectedObject, fileCollections }): ReactElement => {

    return (
        <>{showDocumentModal && <Portal>
            <Modal
                className={'bv-object-view-mobile-floorplan-modal bv-ovm'}
                showModal={showDocumentModal}
                modalPaperStyle={{ height: 'auto', minHeight: '30%' }}
                onBackdropClick={():void => setShowDocumentModal(false)}
            >
                <div className={'bv-objectview-close'} style={{ width: '3rem', height: '3rem', borderRadius: '1.5rem' }} onClick={():void => setShowDocumentModal(false)}>
                    <ObosX className={'bv-obos-x'}
                        style={{
                            width: '1.5rem',
                            height: '1.5rem',
                            padding: '0.75rem' }} />
                </div>
                <div className={'bv-doc-wrapper'}>
                    <h2 className="bv-doc-header">Ladda ner dokument</h2>
                    {selectedObject?.documentCollectionId && fileCollections?.find(fC => fC.id === selectedObject.documentCollectionId)?.files.map(f => {
                        return <a
                            key={f.id}
                            className='bv-doc-link'
                            href={f.url?.original}
                            target="__blank">
                            <p className='bv-doc-text'>{f.listName}</p><ObosDownload className={'bv-ov-doc-icon'}/>
                        </a>;
                    })}
                </div>
            </Modal>
        </Portal>}</>
    );
};


export default ObjectViewMobileDocumentModal;